import { lazy } from 'solid-js'
import { messages } from '../../pages/mobile-oauth-callback-page/mobile-oauth-callback-page-routing.messages.en.js'

// TENANT-5315: Core Auth's registered redirect for the mobile OAuth client.
// Deliberately NOT in sitemap-routes.js — it is a callback, not a page anyone
// should reach from search.
export default {
    component: lazy(() => import('../../pages/mobile-oauth-callback-page/mobile-oauth-callback-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/mobile-oauth-callback',
    showFooter: false,
    showHeaderMenu: false,
    showSidebar: false,
    titleMessage: messages.titleMessage,
}
